<template>
  <div
    class="
      doCaptchaPopupContainer
      flexContainer
      yCenterContainer
      columnContainer
    "
  >
    <button @click="closePopup" class="closeButton" style="color: #000000">anuluj</button>
    <vue-hcaptcha
      size="compact"
      :sitekey="captchaSiteKey"
      @verify="verifyCaptcha"
    ></vue-hcaptcha>
  </div>
</template>

<script>
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";

export default {
  data() {
    return {
      captchaSiteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
    };
  },
  methods: {
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
    verifyCaptcha() {
      this.$store.dispatch("verifyCaptcha");
    },
  },
  components: {
    VueHcaptcha,
  },
};
</script>

<style scoped>
.doCaptchaPopupContainer {
  width: 20%;
  height: 25%;
  margin-top: 17%;
  margin-left: 33%;
  border: 2px solid;
  background-color: #ffffff;
  justify-content: space-between;
  padding: 0.5%;
  box-shadow: 0 0 0 4px #ffffff, 0 0 0 6px #000000;
}
</style>
